import React, { Component } from 'react'
import axios from 'axios'
import { sn_url } from '../../utils/js/endpoints'
import Modal from './../../components/modal/Modal'
import Providers from './Providers'
import { fireAnalytics } from '../../utils/js/analytic_helpers'
import { handleError } from 'utils/js/error_helpers'

import './FindMyChannels.scss'

class FindMyChannels extends Component {
    constructor() {
        super()
        this.getProviders_source = null
        this.mounted = false
        this.state = {
            postalcodeOK: false,
            postalcodeVal: '',
            submitted: false,
            providers: [],
            providersStatus: '',
            providersModalOpen: false,
        }
    }

    componentDidMount() {
        this.mounted = true
        const localPC = localStorage.getItem('postalCode')
        this.setState({ postalcodeVal: localPC })
    }

    componentWillUnmount() {
        this.mounted = false
        if (this.getProviders_source) this.getProviders_source.cancel()
    }

    checkPostalCode = e => {
        let val = e.target.value

        this.setState({
            postalcodeOK: val.match(/[a-zA-Z][0-9][a-zA-Z](-| |)[0-9][a-zA-Z][0-9]/),
            postalcodeVal: val.replace(/-|\s/g, ''),
        })
    }

    getProviders = e => {
        e.preventDefault()

        const { postalcodeOK, postalcodeVal } = this.state

        this.setState({
            submitted: true,
        })

        if (!postalcodeOK) return null

        localStorage.setItem('postalCode', postalcodeVal)

        this.getProviders_source = axios.CancelToken.source()

        this.setState({
            submitted: true,
            providersStatus: 'loading',
        })

        fireAnalytics(
            'findmychannel',
            'find my channel schedule',
            3,
            window.location.href || document.URL,
            'Schedule Grid',
            'ANALYTIC_EVENT_BROADCAST_SCHEDULE'
        )

        let endpoint = `${sn_url}/wp-admin/admin-ajax.php?action=get_channel_providers&postalcode=${postalcodeVal}`

        axios
            .get(endpoint, {
                cancelToken: this.getProviders_source.token,
                headers: { 'Content-Type': 'application/json' },
            })
            .then(response => {
                if (this.mounted) {
                    this.setState({
                        providers: response.data,
                        providersStatus: 'success',
                        providersModalOpen: true,
                    })
                }
                this.getProviders_source = null
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    this.setState({
                        providers: [],
                        providersStatus: 'error',
                        providersModalOpen: false,
                    })
                }
                handleError(error)
                this.getProviders_source = null
            })
    }

    toggleProvidersModal = () => {
        this.setState({
            providersModalOpen: !this.state.providersModalOpen,
        })
    }

    render() {
        let postal_code_error_class =
            this.state.submitted && !this.state.postalcodeOK ? 'error' : ''

        let providers_btn_action_class =
            this.state.providersStatus === 'loading'
                ? 'loading'
                : this.state.providersStatus === 'error'
                ? 'error'
                : ''

        return (
            <div className="FindMyChannels__cont">
                <div className="channel_input_cont">
                    <div className="message">Find My Channels:</div>
                    <form className="actions" onSubmit={this.getProviders}>
                        <input
                            className={`text_input ${postal_code_error_class}`}
                            type="text"
                            placeholder={`${this.state.postalcodeVal || 'Postal Code'}`}
                            onChange={this.checkPostalCode}
                        />
                        <div className={`button_input_cont ${providers_btn_action_class}`}>
                            <input className="button_input" type="submit" value="Submit" />
                        </div>
                    </form>
                </div>
                <p className="desc">Find the channel numbers in your area.</p>
                <Modal
                    modalOpen={this.state.providersModalOpen}
                    modalToggle={this.toggleProvidersModal}
                >
                    <Providers
                        providers={this.state.providers}
                        modalToggle={this.toggleProvidersModal}
                        addChannels={this.props.addChannels}
                    />
                </Modal>
            </div>
        )
    }
}

export default FindMyChannels
